import Vue from 'vue'
import Helpers from "@/helpers.js"

export default {
  setHomepageData(state, data) {
    state.flagged_buckets = data.flagged_buckets
    state.flagged_cases = data.flagged_cases
    state.recent_cases = data.recent_cases.map((recentCase) => Object.assign({ isFlagged: false }, recentCase))
    state.user_events = data.user_events
    state.loading = false
    state.flaggedCasesLoading = false
  },
  requestingHomepageData(state) {
    state.loading = true
    state.timeline.loading = true
  },
  formatUserTimelineEvents(state, data) {
    const userEvents = this.state.homepage.user_events
    // Check if only 'eventObjIndex' update
    if (data.eventIndex === null) {
      // Update event object
      userEvents[data.eventObjIndex].dateFormatted = data.dateFormatted
    } else {
      // Update individual event (in event object)
      userEvents[data.eventObjIndex].events[data.eventIndex].createdAtFormatted = data.createdAtFormatted
    }
  },
  updateRecentCases(state, { cases, caseTypes }) {
    const ctMap = {}
    for (const ct of caseTypes) {
      ctMap[ct.id] = ct
    }
    if (caseTypes) {
      state.recent_cases = (cases || []).map(rc => {
        const caseType = ctMap[rc.caseTypeId]
        rc.isFlagged = true
        rc.icon = { code: caseType.iconCode, set: caseType.iconSet }
        rc.caseType = Helpers.caseTypeName(caseType)
        return rc
      })
      state.recentCasesLoading = false
    }
  },
  appendUserTimelineEvents(state, data) {
    const eventDateRef = {}
    const eventsToAppend = []

    // Loop through state events and store indexes for easy accessing - and less iterations of loops
    for (let x = 0; x < state.user_events.length; x++) {
      eventDateRef[state.user_events[x].date] = {
        index: x
      }
    }

    // Check if event date already in state
    for (let y = 0; y < data.length; y++) {
      if (eventDateRef[data[y].date]) {
        // Add to existing dateEventObj - avoid duplicate dates in timeline e.g. 'Today' twice
        const eventDateIndex = eventDateRef[data[y].date].index
        const eventsToPush = data[y].events
        // Concat to eventObject's events
        state.user_events[eventDateIndex].events = state.user_events[eventDateIndex].events.concat(eventsToPush)
      } else {
        eventsToAppend.push(data[y])
      }
    }
    // If any dateEvent objects, then add to state
    if (eventsToAppend.length > 0) state.user_events = state.user_events.concat(eventsToAppend)
  },
  updateRecentCase(state, caseData) {
    Vue.set(state.recent_cases, caseData.index, caseData.data)
  },
  updateRecentCaseFlag(state, caseData) {
    state.recent_cases[caseData.index].isFlagged = caseData.isFlagged
  },
  setRecentCasesLoading(state, data) {
    state.recentCasesLoading = data
  }
}
